import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import React from "react";

import { ClientDetailsContainer, ClientDetailsRow } from "./style";

type Props = {
  applicationId: string;
  serviceBusNamespace: string;
};

type PairProps = {
  label: string;
  value: string;
};

const LabelValuePairWithCopyButton: React.FC<PairProps> = ({
  label,
  value,
}) => (
  <ClientDetailsRow className="tile is-parent">
    <div className="tile is-child is-4">
      <span>
        <b>{label}</b>
      </span>
    </div>
    <div className="tile is-child is-6">
      <span>{value}</span>
    </div>
    <div className="tile is-child is-2">
      <CopyToClipboard value={value} label={label} />
    </div>
  </ClientDetailsRow>
);

const ClientDetails: React.FC<Props> = ({
  applicationId,
  serviceBusNamespace,
}) => (
  <ClientDetailsContainer className="tile is-ancestor is-vertical">
    <LabelValuePairWithCopyButton label="Client ID" value={applicationId} />
    <LabelValuePairWithCopyButton
      label="Service Bus namespace"
      value={serviceBusNamespace}
    />
    <LabelValuePairWithCopyButton
      label="Tenant ID"
      value={process.env.REACT_APP_AUTH_TENANT_ID!}
    />
  </ClientDetailsContainer>
);

export default ClientDetails;
